import script from "./mx.vue?vue&type=script&lang=js"
export * from "./mx.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__